import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { RadioToggle } from '../../../internal/components/RadioToggle';
import { generateDataTestId } from '../../../internal/utils';
import * as styles from './styles/styles.module.css';
import { UIText1, UIText2 } from '../../../typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RadioCellComponent = /*#__PURE__*/React.forwardRef(function RadioCell(props, ref) {
  const {
    disabled,
    invalid,
    title,
    description,
    image,
    dataTestId
  } = props;
  const titleRef = React.useRef(null);
  return /*#__PURE__*/_jsxs(ControlInputContainer, _objectSpread(_objectSpread({}, props), {}, {
    type: "radio",
    className: clsx(styles['radio-cell'], disabled && styles['disabled'], invalid && styles['invalid']),
    ref: ref,
    children: [/*#__PURE__*/_jsx(RadioToggle, {
      className: styles['indicator']
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['wrapper'],
      children: [image && /*#__PURE__*/_jsx("span", {
        className: styles['image'],
        "data-testid": generateDataTestId(dataTestId, ['image']),
        children: image
      }), /*#__PURE__*/_jsxs("span", {
        ref: titleRef,
        className: styles['title'],
        children: [/*#__PURE__*/_jsx(UIText1, {
          color: "text-primary-default",
          "data-testid": generateDataTestId(dataTestId, ['title']),
          children: title
        }), description && /*#__PURE__*/_jsx(UIText2, {
          color: "text-secondary-default",
          "data-testid": generateDataTestId(dataTestId, ['description']),
          children: description
        })]
      })]
    })]
  }));
});

/**
 * Компонент RadioCell с тайтлом
 *
 * По-умолчанию используем на мобилке. Но если задача требует более крупного контрола, то допустимо использование мобильной версии на деске.
 *
 * [Ссылка на макет](https://www.figma.com/design/u5m0yseMVnhiC2eTOipMel/DS-89-Radio)
 *
 * @export
 * @param {IRadioProps} props
 * @returns
 */
export const RadioCell = /*#__PURE__*/React.memo(RadioCellComponent);